const $ = require('jquery');
require('../../utils/jquery-extensions');
const addressAutocomplete = require('../../components/googlePlacesAutocomplete');
const hubbox = require('../../hubbox/hubbox');
const {handleCustomError, pushUserIdentifier} = require('../../utils/contentSquareHandler');
const logincheckout = require('./login');
const address = require('./address');
const billingshipping = require('./billingshipping');
const billing = require('./billing');
const summary = require('./summary');
const adyenRestSuggestionDropdown = require('./adyen/adyenRestSuggestionDropdown');
const adyenComponents = require('./adyen/adyen_components');
const adyenComponentCheckout = require('./adyen/adyen_component_checkout_additional');
const orderconfirmation = require('./orderconfirmation');
const adyenWaitingPage = require('./adyen/adyen_waiting_page');

/**
 * @function Initializes the page events depending on the checkout stage (shipping/billing)
 */
exports.init = function () {
    logincheckout.init();
    address.init();
    if ($('.checkout-shipping').length > 0) {
        billingshipping.init();
        // BSDDEV-2192: Google Address Autocomplete
        if (addressAutocomplete.enabled) {
            addressAutocomplete.init();
        }
        /* } else if ($('.checkout-multi-shipping').length > 0) {
        multiship.init(); */
    }

    if ($('.checkout-billing').length > 0) {
        billing.init();
        adyenRestSuggestionDropdown.init();
        adyenComponents.init();

        const userEmail = $('.js-customer-email').text() || null;

        pushUserIdentifier(userEmail);
    }

    if ($('.order-summary-footer').length > 0) {
        summary.init();
    }

    if ($('.checkout-confirmation').length > 0) {
        orderconfirmation.init();
    }

    if ($('.shipping-type-select').length > 0) {
        hubbox.init();
    }

    if ($('.js-checkout-error-placeholder').length > 0) {
        const errorMessage = $('.js-checkout-error-placeholder').data('error-message');
        handleCustomError(errorMessage, 'checkoutAddressError');
    }

    summary.attachBackBtnEvent();

    adyenWaitingPage.init();
    adyenComponentCheckout.init();
};
